import { SvgBase } from "../svg.base";

export const AntentIndicator = () => (
  <SvgBase
    width="6"
    height="18"
    viewBox="0 0 6 18"
  >
    <path
      fill="#A3244C"
      d="M.415 15.407A2.59 2.59 0 0 1 3 12.814a2.59 2.59 0 0 1 2.585 2.593A2.59 2.59 0 0 1 3 18a2.59 2.59 0 0 1-2.585-2.593"
    />
    <path
      fill="#C92659"
      d="M.415 9.356A2.59 2.59 0 0 1 3 6.763a2.59 2.59 0 0 1 2.585 2.593A2.59 2.59 0 0 1 3 11.949 2.59 2.59 0 0 1 .415 9.356"
    />
    <path
      fill="#F02867"
      d="M.415 3.305A2.59 2.59 0 0 1 3 .712a2.59 2.59 0 0 1 2.585 2.593A2.59 2.59 0 0 1 3 5.898 2.59 2.59 0 0 1 .415 3.305"
    />
  </SvgBase>
);


